import http from './http'
import Resource from './resource'

const path = 'admin/web-clients'

class WebClients extends Resource {
  constructor(_http) {
    super(path, _http)
  }

  select(opt = {}) {
    return this.http.get(`api/${path}/select/list`, opt)
  }
}

const WebClientsRequest = new WebClients(http)

export default WebClientsRequest
